import {AddDashboardService} from "./service/AddDashboardService";
import {addDashboardDialog, AddDashboardDialog} from "./component/AddDashboardDialogComponent";

export default function(parentModule: string): string {
    const rootModule = `${parentModule}.add-dashboard`;
    return angular.module(rootModule, [])
                  .component(AddDashboardDialog, addDashboardDialog())
                  .service(AddDashboardService.id, AddDashboardService)
                  .name;
}
